    import {Component, Inject, OnInit} from 'ng-metadata/core';
    import {SearchService} from '../search.service';
    import {FacetService} from '../facet/facet.service';
    import {SearchStateService} from '../searchState.service';
    import {PrimolyticsService,beacon} from '../../analytics/primolytics.service';
    import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';
    import {BriefResultService} from "../briefResult/briefResult.service";
    const omit = require('lodash/omit');


    @Component({
            selector: "prm-breadcrumbs",
            templateUrl: 'components/search/breadcrumbs/breadcrumbs.html'
        })

     export class PrmBreadcrumbs implements OnInit{

        /* private members */  
        private _selectedFacets = []; // the current facet list
 
        constructor(@Inject('$mdSidenav') private $mdSidenav: angular.material.ISidenavService,
                private searchService : SearchService,
                private facetService : FacetService,
                private searchStateService : SearchStateService,
                private primolyticsService : PrimolyticsService,
                private briefResultService: BriefResultService,
                private configurationUtil : ConfigurationUtil,
                @Inject('$q') private $q: ng.IQService) {

        }


        ngOnInit(){
            let searchObjectFacets = this.searchStateService.getSearchObject().facets;
            this.$q.all(searchObjectFacets.map((facet)=> facet.translationsPromise)).then(()=>{
                searchObjectFacets = searchObjectFacets.map(facet=> omit(facet, 'translationsPromise'));
                this._selectedFacets = this.facetService.transformActiveFacets(searchObjectFacets);

            })

        	
        }
        /**
         * @ngdoc method
         * @name removeFacet
         * @methodOf starter.controller:FacetController
         * @description
         * Remove facet from query and perform a new search
         * Performs a search together with facets
         * @param {string} index - The facet array index which should be removed
         */
        @beacon({'p':'refine'})
        removeFacet(cur) {
            if(cur.persistent){
                this.removeStickyFacet(cur);
            }
            let facetStrings = [];
            if (cur.mergedFacets){
                facetStrings = cur.mergedFacets.map((facet) => facet.name+','+facet.type+','+facet.value);
            }
            facetStrings.push(cur.name+','+cur.type+','+cur.value);
            this.facetService.facetSearch({facet:facetStrings, remove: true});
        }

        private clearAllFacets(){
            this.facetService.facetSearch({removeAll: true});
        }

        toggleFacets() {
            this.$mdSidenav('right').toggle();
        }
  
        public facetLabel(facet) {
            return this.facetService.facetLabel(facet);
        }
        
        get facets() {
            return this.facetService.getResults();
        }

        set facets(facets) {

        }
        
        public addStickyFacet(facet) {
            this.addStickyFacetBeacon(facet);
            return this.facetService.addStickyFacet(facet);
        }
        
        @beacon({'p':'setPersistentFacet'})
        public addStickyFacetBeacon(facet) {}
        
        public removeStickyFacet(facet) {
            return this.facetService.removeStickyFacet(facet);
        }

        get selectedFacets() {
            return this._selectedFacets;
        }

        set selectedFacets(dummy) {

        }

        get searchInfo() {
            return this.searchService.getResultObject().info;
        }
        
        
         public getFacetDefaultValue(facet) {
            return this.facetService.getFacetDefaultValue(facet);
         }
        
        public getTextDirection(facet) {
            let text = this.getFacetDefaultValue(facet);
            return this.briefResultService.getTextDirection(text);
         }

    }





// WEBPACK FOOTER //
// ./src/main/webapp/components/search/breadcrumbs/breadcrumbs.directive.ts